import React from 'react';
import styled from 'styled-components';

import Loading from '../../components/Loading';
import JobTable from './JobTable';

const Container = styled.div`
`;

const Section = styled.div`
  width: 100%;
`;

const SectionTitle = styled.p`
  width: 100%;
  font-family: AvenirNext-Bold;
  font-size: 34px;
`;

const SectionSubtitle = styled.p`
  width: 100%;
  font-size: 18px;
`;


class IssueDashboard extends React.Component {
  // TODO move the filtration to the API entirely
  overdueThirdPartyPayJobs = () => [ ...this.props.jobs, ...this.props.unexpirable_jobs].filter((job) => {
    //  card charge failed, or has third party in it
    const statusToCompare = job.status === 'expiredJob' ? job.ledger.slice(-2)[0].new_status : job.status;
    return  ['jobWaitingForThirdPartyPay', 'cardChargeFailed'].indexOf(statusToCompare) !== -1;
  })

  // TODO move the filtration to the API entirely
  overdueTalentSelection = () => [...this.props.jobs, ...this.props.unexpirable_jobs].filter((job) => {
    // has waiting for talent in any form - past or present
    const statusToCompare = job.status === 'expiredJob' ? job.ledger.slice(-2)[0].new_status : job.status;
    return  ['jobWaitingForThirdPartyPayAndTalentAccept', 'waitingForTalentToAccept'].indexOf(statusToCompare) !== -1;
  })

  render() {
    const overdueThirdPartyPayFields = [
      {id: 'is_expired', title: 'Is Expired'},
      {id: 'name', title: 'Name' },
      {id: 'client_admin', title: 'Client' },
      {id: 'status', title: 'Job Status' },
      {id: 'rate', title: 'Rate' },
      {id: 'total_rate', title: 'Total Rate' },
      {id: 'job_dates', title: 'Job Dates' },
      {id: 'collected_payment', title: 'Collected Wire / Check' },
      {id: 'internal_notes', title: 'Internal Notes' },
      {id: 'edit_internal_notes', title: 'Edit Internal Notes' },
      {id: 'engineering_details', title: 'Engineering Details' },
    ];
    const overdueTalentSelection = [
      {id: 'is_expired', title: 'Is Expired'},
      {id: 'name', title: 'Name' },
      {id: 'client_admin', title: 'Client' },
      {id: 'status', title: 'Job Status' },
      {id: 'rate', title: 'Rate' },
      {id: 'total_rate', title: 'Total Rate' },
      {id: 'engineering_details', title: 'Engineering Details' },
      {id: 'internal_notes', title: 'Internal Notes' },
      {id: 'edit_internal_notes', title: 'Edit Internal Notes' },
    ];

    const commonProps = {
      confirmWireCheck: this.props.confirmWireCheck,
      showEditModal: this.props.showEditModal,
    }

    const deferredPaymentProps = {
      ...commonProps,
      jobs: this.overdueThirdPartyPayJobs(),
      fields: overdueThirdPartyPayFields,
    }

    const chasingProps = {
      ...commonProps,
      jobs: this.overdueTalentSelection(),
      fields: overdueTalentSelection,
    }

    const isDeferredPaymentTab = this.props.bucket === 'deferred_payments'
    const tableProps = isDeferredPaymentTab ? deferredPaymentProps : chasingProps

    return (
      <Container>
        <Section>
          {isDeferredPaymentTab ? (
            <>
              <SectionTitle>Deferred Payments</SectionTitle>
              <SectionSubtitle>Owner: Muhuan </SectionSubtitle>
              <SectionSubtitle>Process: The goal is to keep this section empty by following up with clients to pay. If a client confirms a job through the system, it will disappear from this list. If client sends us check or wire, there is no record in our database so we need to manually confirm it has been a) received b) entered in Quickbooks.</SectionSubtitle>
            </>
          ) : (
            <>
              <SectionTitle>Chasing Talent To Accept</SectionTitle>
              <SectionSubtitle>Owner: Chanel / Andrea </SectionSubtitle>
            </>
          )}

          {this.props.loading && !this.props.jobs.length ? <Loading /> : <JobTable {...tableProps} />}
        </Section>
      </Container>
    );
  }
}

export default IssueDashboard;
